import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
function OurPartners() {
    useEffect(() => {
        Aos.init({
            once: true,
            duration: 2000
        })
    }, [])
    const clients = [
        {
            "name": "Bupa",
            "logo": "images/brand-logo/partner-brands/bupa.webp"
        },
        {
            "name": "NHS",
            "logo": "images/brand-logo/partner-brands/nhs.webp"
        },
        {
            "name": "Kapruka",
            "logo": "images/brand-logo/partner-brands/kapruka.webp"
        },
        {
            "name": "Hajj Committee India",
            "logo": "images/brand-logo/partner-brands/haj-commitee.webp"
        },
        {
            "name": "Government of India",
            "logo": "images/brand-logo/partner-brands/government-india.webp"
        },
        {
            "name": "Hero",
            "logo": "images/brand-logo/partner-brands/hero.webp"
        },
        {
            "name": "Honda",
            "logo": "images/brand-logo/partner-brands/honda.webp"
        },
        {
            "name": "Aeromedical",
            "logo": "images/brand-logo/partner-brands/aeromedical.webp"
        },
        {
            "name": "Mahindra",
            "logo": "images/brand-logo/partner-brands/mahindra.webp"
        },
        {
            "name": "Zowar",
            "logo": "images/brand-logo/partner-brands/zowar.webp"
        },
        {
            "name": "AMSOIL",
            "logo": "images/brand-logo/partner-brands/amsoil.webp"
        },
        {
            "name": "Benchmark Mortgage",
            "logo": "images/brand-logo/partner-brands/benchmark.webp"
        },
        {
            "name": "Essar",
            "logo": "images/brand-logo/partner-brands/essar.webp"
        },
        {
            "name": "Hanadoc",
            "logo": "images/brand-logo/partner-brands/hanadoc.webp"
        },
        {
            "name": "Harley Medic International",
            "logo": "images/brand-logo/partner-brands/harley_medic.webp"
        },
        {
            "name": "Everything Genetic",
            "logo": "images/brand-logo/partner-brands/everything_gentic.webp"
        },
        {
            "name": "Annachi",
            "logo": "images/brand-logo/partner-brands/annachi.webp"
        },
        {
            "name": "Sesapay",
            "logo": "images/brand-logo/partner-brands/sesa_pay.webp"
        },
        {
            "name": "Izikare",
            "logo": "images/brand-logo/partner-brands/izikare.webp"
        },
        {
            "name": "Transpion",
            "logo": "images/brand-logo/partner-brands/transpion.webp"
        }
    ]

    return (
        <section className="home-partners-block r-bg-x sec-pad " id='partners'>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="sec-heading text-center pera-block">
                            <h2><span className="ree-text rt40">Our Clients</span> <span className="ree-text rt40"></span></h2>
                            <p>We have had the privilege of working with renowned organizations</p>
                        </div>
                    </div>
                </div>
                <div className="row mt30">
                    <div className="col-lg-12">
                        <div className="clients-logos text-center col-12">
                            <ul className="row text-center d-flex justify-content-center align-items-center clearfix">
                                {clients.map((client, index) =>
                                    <li className="p-0 col-lg-2 col-md-3 col-sm-4 col-4 li-bg my-2 mx-2" data-aos="fade-in" data-aos-delay="100" key={index}>
                                        <div className="brand-logo"><img src={client.logo} alt={client.name} className="img-fluid" /></div>
                                        {/* <p>{client.name}</p> */}
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OurPartners